<template>
	<div>
		<div>
			<p><b>תאריך פרעון</b></p>
			<date-time v-model="payment_date"></date-time>
		</div>
		<div class="vertical_space"></div>
		<div class="vertical_space"></div>
		<p><b>תנאי תשלום:</b></p>
		<div class="flex">
			<a @click="setPaymentTerms('cheque')" class="button is-info" :class="{ 'is-outlined': payment_terms != 'cheque' }">שיק</a>
			<div class="horizontal_space"></div>
			<a @click="setPaymentTerms('bank_transfer')" class="button is-info" :class="{ 'is-outlined': payment_terms != 'bank_transfer' }">העברה בנקאית</a>
		</div>
		<div v-if="payment_terms == 'cheque'">
			<div class="vertical_space"></div>
			<div class="vertical_space"></div>
			<div>
				<p><b>מספר שיק</b></p>
				<input v-model="cheque_number" type="text">
			</div>
			<div>
				<p><b>בנק</b></p>
				<select v-model="bank_number">
					<option v-for="bank in banks_list" :value="bank.id">{{ bank.text }}</option>
				</select>
			</div>
			<div class="vertical_space"></div>
			<div class="vertical_space"></div>
		</div>
		<div v-if="payment_terms == 'bank_transfer'">
			<div class="vertical_space"></div>
			<div class="vertical_space"></div>
			<div>
				<p><b>אסמכתא</b></p>
				<input v-model="reference" type="text">
			</div>
		</div>
	</div>
</template>
<script>
	import DateTime from '@/components/DateTime'
	export default {
		name: 'receipt-form',
		data(){
			return {
				payment_date: undefined,
				payment_terms: undefined,
				cheque_number: '',
				bank_number: '',
				branch_number: '0',
				account_number: '0',
				reference: '',
				banks_list: [{"text":"בנק יהב לעובדי המדינה בע\"מ","id":4},{"text":"בנק הדואר","id":9},{"text":"בנק לאומי לישראל בע\"מ","id":10},{"text":"בנק דיסקונט לישראל בע\"מ","id":11},{"text":"בנק הפועלים בע\"מ","id":12},{"text":"בנק אגוד לישראל בע\"מ","id":13},{"text":"בנק אוצר החייל בע\"מ","id":14},{"text":"בנק מרכנתיל דיסקונט בע\"מ","id":17},{"text":"הבנק הדיגיטלי הראשון (בהקמה) בע\"מ","id":18},{"text":"בנק מזרחי טפחות בע\"מ","id":20},{"text":"Citibank N.A","id":22},{"text":"HSBC  Bank plc","id":23},{"text":"יובנק בע\"מ","id":26},{"text":"Barclays Bank PLC","id":27},{"text":"בנק למסחר בע\"מ (לבנק מונה מפרק זמני)","id":30},{"text":"הבנק הבינלאומי הראשון לישראל בע\"מ","id":31},{"text":"בנק ערבי ישראלי בע\"מ","id":34},{"text":"SBI State Bank of India","id":39},{"text":"בנק מסד בע\"מ","id":46},{"text":"מרכז סליקה בנקאי בע\"מ","id":50},{"text":"בנק פועלי אגודת ישראל בע\"מ","id":52},{"text":"בנק ירושלים בע\"מ","id":54},{"text":"שירותי בנק אוטומטיים בע\"מ","id":59},{"text":"חסך קופת חסכון לחינוך בע\"מ, חיפה","id":65},{"text":"בנק דקסיה ישראל בע\"מ","id":68},{"text":"בנק ישראל","id":99}]
			}
		},
		watch: {
			payment_date(){
				this.updateParent()
			},
			payment_terms(){
				this.updateParent()
			},
			cheque_number(){
				this.updateParent()
			},
			bank_number(){
				this.updateParent()
			},
			branch_number(){
				this.updateParent()
			},
			account_number(){
				this.updateParent()
			},
			reference(){
				this.updateParent()
			}
		},
		created(){
			this.sortBanksList()
		},
		methods: {
			sortBanksList(){
				this.banks_list = this.banks_list.sort((a, b) => {
					return a.text > b.text
				})
			},
			setPaymentTerms(payment_terms){
				this.payment_terms = payment_terms
			},
			updateParent(){
				this.$emit('input', {
					payment_terms: this.payment_terms,
					payment_date: this.payment_date,
					cheque_number: this.cheque_number,
					bank_number: this.bank_number,
					branch_number: this.branch_number,
					account_number: this.account_number,
					reference: this.reference
				})
			}
		},
		components: {
			DateTime
		}
	}
</script>